export const isIsoNowBetween = (startIso: string, endIso: string) => {
  const now = new Date()
  return now >= new Date(startIso) && now <= new Date(endIso)
}
export const formatDateIso = (d = new Date()) => d.toISOString()
